var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 0C7.78089 0 7.33317 0.447715 7.33317 1V2H1.6665C1.11422 2 0.666504 2.44772 0.666504 3C0.666504 3.55228 1.11422 4 1.6665 4L20.3332 4C20.8855 4 21.3332 3.55228 21.3332 3C21.3332 2.44772 20.8855 2 20.3332 2H14.6665V1C14.6665 0.447715 14.2188 0 13.6665 0L8.33317 0Z",
    fill: "#101112",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 17L14.3736 18.9595C14.7641 19.3501 14.7641 19.9832 14.3736 20.3738C13.9831 20.7643 13.3499 20.7643 12.9594 20.3738L10.9998 18.4142L9.04029 20.3738C8.64976 20.7643 8.0166 20.7643 7.62607 20.3738C7.23555 19.9832 7.23555 19.3501 7.62608 18.9596L9.58564 17L7.62606 15.0404C7.23554 14.6499 7.23554 14.0167 7.62606 13.6262C8.01659 13.2357 8.64975 13.2357 9.04028 13.6262L10.9998 15.5858L12.9594 13.6262C13.3499 13.2357 13.9831 13.2357 14.3736 13.6262C14.7641 14.0167 14.7641 14.6499 14.3736 15.0404L12.4141 17Z",
    fill: "#101112",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9884 7.55623C3.04467 7.0498 3.47274 6.66667 3.98229 6.66667H18.0174C18.5269 6.66667 18.955 7.0498 19.0113 7.55623L19.2781 9.95803C19.7619 14.3118 19.7619 18.7058 19.2781 23.0595L19.2519 23.296C19.0598 25.0242 17.7204 26.4022 15.9984 26.6433C12.6822 27.1076 9.31747 27.1076 6.00127 26.6433C4.27923 26.4022 2.93983 25.0242 2.74781 23.296L2.72154 23.0595C2.23779 18.7057 2.23779 14.3118 2.72154 9.95803L2.9884 7.55623ZM4.87733 8.66667L4.70931 10.1789C4.24186 14.3859 4.24186 18.6317 4.7093 22.8386L4.73558 23.0751C4.82665 23.8947 5.46187 24.5483 6.27857 24.6626C9.4108 25.1011 12.5889 25.1011 15.7211 24.6626C16.5378 24.5483 17.173 23.8947 17.2641 23.0751L17.2904 22.8387C17.7578 18.6317 17.7578 14.3859 17.2904 10.1789L17.1223 8.66667H4.87733Z",
    fill: "#101112",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/delete_gray.2b1eaefa80807266e3941c81639fd62d.svg";
export { ForwardRef as ReactComponent };